import { Link } from "react-router-dom";
import {
  Sparkles, Flower2, Moon, Droplet, Leaf, Wind, Shield, HeartPulse, Compass,
  BookHeart, Sun, Baby, ArrowRight,
} from "lucide-react";
import { TREATMENTS } from "@/lib/site";
import { useSEO } from "@/lib/seo";
import SectionHeading from "@/components/SectionHeading";

const iconMap = { Sparkles, Flower2, Moon, Droplet, Leaf, Wind, Shield, HeartPulse, Compass, BookHeart, Sun, Baby };

export default function Treatments() {
  useSEO({
    title: "Treatments — Ayurvedic Care for Women",
    description: "Explore all Ayurvedic treatments at Nari Arogya — PCOS, infertility, pregnancy care, menopause, Garbha Sanskar and more, guided by Dr. Anita Chaudhari.",
    path: "/treatments",
  });

  return (
    <>
      <section className="pt-32 pb-14 lotus-bg" data-testid="treatments-hero">
        <div className="na-container text-center">
          <SectionHeading
            eyebrow="Our Care"
            title="Ayurvedic treatments, tailored to you"
            subtitle="From your first cycle to your last — Nari Arogya provides root-cause care rooted in classical Ayurveda and modern diagnostics."
            align="center"
          />
        </div>
      </section>

      <section className="section">
        <div className="na-container grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TREATMENTS.map((t) => {
            const Icon = iconMap[t.icon] || Sparkles;
            return (
              <Link
                to={`/treatments/${t.slug}`}
                key={t.slug}
                className="na-card p-7 group"
                data-testid={`treatment-card-${t.slug}`}
              >
                <div className="w-14 h-14 rounded-2xl bg-[color:var(--na-teal)]/10 text-[color:var(--na-teal)] flex items-center justify-center group-hover:bg-[color:var(--na-maroon)] group-hover:text-white transition">
                  <Icon size={26} />
                </div>
                <h3 className="mt-5 text-2xl">{t.title}</h3>
                <p className="mt-2 text-sm text-[color:var(--na-muted)] leading-relaxed">{t.short}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--na-teal)] group-hover:text-[color:var(--na-maroon)] transition">
                  Learn more <ArrowRight size={14} />
                </span>
              </Link>
            );
          })}
        </div>
      </section>
    </>
  );
}
